module.exports = __webpack_public_path__ + "assets/img/32_645_big.1f4e10db.jpg";